import { useSelector } from 'react-redux';
import { LIGHT_THEME } from '@rsos/theme/constants';

/**
 * Get the selected theme name.
 * @returns String
 */
const useSelectedTheme = () => {
  const themeName = useSelector(state => {
    const currentRole = state.sinatra.user.currentRole;
    const attributes = state.sinatra.user.profile?.attributes;
    const applicationName = currentRole?.application;

    return attributes?.[applicationName]?.theme_settings?.theme || LIGHT_THEME;
  });

  return themeName;
};

export default useSelectedTheme;
